import React from 'react';

import {observer} from "mobx-react";
import {PredictionOdds} from "./prediction.odds";
import {RateOptionViewModel} from "../../../../../domain/common/odds/rate-option/models/rate-option.view-model";
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionsOddsRow = observer(({
                                              prediction,
                                              controller,
                                              betsImpressionParams,
                                              showOdds,
                                            }) => {
  const {state} = controller;
  const {odds, hasOdds, selectedVoteNum, enableVoting} = prediction;
  const shouldRenderOdds = hasOdds && showOdds && state.appState.showOdds;

  return (
    shouldRenderOdds ? <div className={classNames(styles.odds_row, {[styles.disable_voting]: !enableVoting})}>
      {
        odds.rateOptions?.map((rateOption: RateOptionViewModel, index: Number) => <PredictionOdds
          key={rateOption.num}
          odds={rateOption}
          controller={controller}
          isFirst={index === 0}
          isLast={index === odds.rateOptions?.length - 1}
          rateOptionsLength={odds.rateOptions?.length}
          isSelected={rateOption.num === selectedVoteNum}
          bookmaker={odds?.bookmaker}
          betsImpressionParams={betsImpressionParams}
          isSingleOdd={odds.isSingleOdd}
        />)
      }
    </div> : null
  )
})
